import { render, staticRenderFns } from "./kredikartodemetipi.vue?vue&type=template&id=d1467d3c&"
import script from "./kredikartodemetipi.vue?vue&type=script&lang=js&"
export * from "./kredikartodemetipi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports